module.exports = __webpack_public_path__ + "img/macbook-frame.4a170d96.png";